import { Link } from 'gatsby'
import React from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
    align-items: center;
    background-color: #ff4c55;
    display: flex;
    height: 599px;
    position: relative;
    text-align: center;

    &::before{
    background-repeat: no-repeat;
    background-size: cover;
    content: "";
    height: 599px;
    mix-blend-mode: lighten;
    position: absolute;
    width: 328px;
    left:0;
    background-image: url('https://i.ibb.co/yQs81Sm/Lighting-Torus-Copy-1-1680x1025-3.png')
    }
    &::after {
    background-repeat: no-repeat;
    background-size: cover;
    content: "";
    height: 599px;
    mix-blend-mode: lighten;
    position: absolute;
    width: 328px;
    right: 0;
    background-image: url('https://i.ibb.co/4MXRvrd/Lighting-Torus-Copy-1-1680x1025-2.png');
    }
`
const TextWrap = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 784px;
    width: 100%;
    margin-left:auto;
    margin-right:auto;
    @media screen and (max-width: 500px) {
        margin: 0 1rem;
    }
`
const Title = styled.h1`
font-weight: 700;
font-size: 40px;
line-height: 44px;
text-align: center;
color: #FFFFFF;
@media screen and (max-width:550px) {
    font-size: 30px;
}
`
const Paragraph = styled.p`
    font-weight: 300;
font-size: 24px;
line-height: 36px;
text-align: center;
color: #FFFFFF;
@media screen and (max-width:600px) {
    font-size: 20px;
}
@media screen and (max-width:500px) {
    font-size: 16px;
}
`
const Button = styled(Link)`
     background: #FFFFFF;
    border-radius: 60px;
    padding: 20px 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    width: 100%;
    color: #39394C;
    align-self: center;
    max-width: 250px;
    position: relative;
    margin: 3rem 0;
    z-index: 1;
    @media screen and (max-width:500px) {
        max-width: 100%;
    }
`
interface TrustProps {
trust: any
}
const Trust: React.FC<TrustProps> = ({trust}) => {
    let str = ''
    if(typeof window !== 'undefined') {
        let location = window.location.pathname
        str = location.replace(/^\/([^\/]*).*$/, '$1')
    }
  return (
    <Wrap>
        <TextWrap>
            <Title>{trust.title.text}</Title>
            <Paragraph>{trust.paragraph.text}</Paragraph>
            <Button to={str === 'fr-fr' ? 'nos-services' : 'services'} className='white'>{trust.btn}</Button>
        </TextWrap>
    </Wrap>
  )
}

export default Trust